import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import './Breadcrumbs.css';

// Route name mapping
const routeNames = {
  '/': 'Início',
  '/institucional': 'Institucional',
  '/contactos': 'Contactos',
  '/projetos': 'Projetos',
  '/intervencao': 'Intervenção',
  '/noticias': 'Notícias',
  '/donativos': 'Ajude-nos',
  '/carreiras': 'Carreiras',
  '/eventos': 'Eventos',
  '/politica-privacidade': 'Política de Privacidade',
  '/politica-cookies': 'Política de Cookies',
  '/elogios-reclamacoes': 'Elogios e Reclamações'
};

const Breadcrumbs = ({ customTitle, className = '' }) => {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);
  
  // Don't show breadcrumbs on homepage or admin pages
  if (location.pathname === '/' || location.pathname.startsWith('/admin')) {
    return null;
  }

  // Build breadcrumb items
  const breadcrumbs = [
    { path: '/', label: 'Início', isHome: true }
  ];

  let currentPath = '';
  pathSegments.forEach((segment, index) => {
    currentPath += `/${segment}`;
    const isLast = index === pathSegments.length - 1;
    
    // Get route name or use custom title for last item
    let label = routeNames[currentPath] || segment;
    
    // If it's the last segment and we have a custom title, use it
    if (isLast && customTitle) {
      label = customTitle;
    }
    
    // Format segment if no mapping found
    if (!routeNames[currentPath] && !customTitle) {
      label = segment
        .replace(/-/g, ' ')
        .replace(/\b\w/g, c => c.toUpperCase());
    }

    breadcrumbs.push({
      path: currentPath,
      label,
      isLast
    });
  });

  return (
    <nav className={`breadcrumbs ${className}`} aria-label="Breadcrumb" data-testid="breadcrumbs">
      <div className="breadcrumbs-container">
        <ol className="breadcrumbs-list">
          {breadcrumbs.map((item, index) => (
            <li key={item.path} className="breadcrumb-item">
              {index > 0 && (
                <ChevronRight size={14} className="breadcrumb-separator" />
              )}
              
              {item.isLast ? (
                <span className="breadcrumb-current" aria-current="page">
                  {item.label}
                </span>
              ) : (
                <Link to={item.path} className="breadcrumb-link">
                  {item.isHome ? (
                    <>
                      <Home size={14} />
                      <span className="sr-only">Início</span>
                    </>
                  ) : (
                    item.label
                  )}
                </Link>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
};

export default Breadcrumbs;
